import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AuthenticatedRoute from './components/AuthenticatedRoute';
import UnauthenticatedRoute from './components/UnauthenticatedRoute';

import Collaborator from './containers/Collaborator';
import S3Uploader from './containers/S3Uploader'
import Login from './containers/Login';
import NotFound from './containers/NotFound';

export default ({ childProps }) => (
      <Switch>
        {/*<AppliedRoute path="/" exact component={Home} props={childProps} />*/}
        <UnauthenticatedRoute path="/login" exact component={Login} props={childProps} />
        {/*<AuthenticatedRoute path="/blog-mgmt" exact component={Home} props={childProps} />*/}
        <AuthenticatedRoute path="/" exact component={Collaborator} props={childProps} />
        <AuthenticatedRoute path="/media-mgmt" exact component={S3Uploader} props={childProps} />
          { /* Finally, catch all unmatched routes */ }
        <Route component={NotFound} />
      </Switch>
);



// WEBPACK FOOTER //
// ./src/Routes.js